import { format } from "date-fns";
import useSWR, { SWRResponse } from "swr";
import { IFundPriceHistoryResponse, IUseFundPriceHistory, IFundPriceHistoryOptions } from "./types";
import commonSwrConfig from "@portal/hooks/commonSwrConfig";
import { useSession } from "@portal/auth/client/SessionProvider";

const useFundPriceHistory: IUseFundPriceHistory = (opts: IFundPriceHistoryOptions) => {
  const { update } = useSession();

  const fetcher = async (url: URL): Promise<IFundPriceHistoryResponse> => {
    const response = await fetch(url, {
      method: "GET",
      headers: [["accepts", "application/json"]],
    });

    if (response.status !== 200) {
      throw response.status;
    }

    const json = await response.json();

    return { fundPriceHistoryList: json };
  };

  if (!opts.isin) {
    throw new Error("Isin is required in useFundPriceHistory.");
  }

  const date = !opts.fromDate ? new Date(new Date().setFullYear(new Date().getFullYear() - 5)) : new Date(opts.fromDate);
  const response: SWRResponse<IFundPriceHistoryResponse, unknown> = useSWR(
    `/api/fundPriceHistory/${opts.isin}?dateFrom=${format(date, "yyyy-MM-dd")}&period=D`,
    fetcher,
    commonSwrConfig(update),
  );

  return {
    fundPriceHistoryList: response.data?.fundPriceHistoryList,
    error: response.error,
    isLoading: !response.data && !response.error,
  };
};

export default useFundPriceHistory;
